import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import I18n from 'I18n';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EPHeader from 'editor-components/header/EPHeader';
import EPNavigationBar from 'editor-components/header/EPNavigationBar';
import UIAutosizedTextInput from 'UIComponents/input/UIAutosizedTextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
// @ts-expect-error not typed
import BaymaxSaveButton from 'ContentEditorUI/components/header/BaymaxSaveButton';
// @ts-expect-error not typed
import { getLastSaveDate } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getHasUndoRedoAccess } from 'ContentEditorUI/redux/selectors/moduleSelectors';
// @ts-expect-error not typed
import UndoRedoButtonContainer from 'ContentEditorUI/containers/UndoRedoButtonContainer';
import { getHasUnsavedChanges, getIsSavePermanentlyDisabled, getSaveState } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getIsUserJitad } from 'ContentEditorUI/redux/selectors/authSelectors';
import { setShouldClearHeaderActiveItem, updateHeaderActiveItem } from 'ContentEditorUI/redux/actions/headerActions';
import { getShouldClearHeaderActiveItem } from 'ContentEditorUI/redux/selectors/headerSelectors';
import ExitButton from 'ContentEditorUI/components/header/ExitButton';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { updateInstanceValue } from 'structured-content-lib/redux/actions/instanceEditActions';
import { SettingsModalSections } from 'structured-content-lib/constants/enums';
import { getIsUngatedForRevisionHistory } from 'case-study-lib/utils/auth';
// @ts-expect-error not typed
import { routeToPage } from 'ContentEditorUI/redux/actions/routingActions';
import { showLoading, hideLoading, openModal
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { updatePatagoniaSettingsModalActiveNavItem } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import CaseStudyPublishButton from './CaseStudyPublishButtonContainer';
import { useAppDispatch, useAppSelector } from '../../utils/store';
import { useNavigationGroups } from '../../hooks/useNavigationGroups';
import { save, selectCanSave, selectHasEmptyTitle } from '../../data/editor/save';
import { selectInstanceGroupId, selectInstanceId, selectInstanceName } from '../../data/editor/instance';
import { getEditorUrl, getManageGroupUrl } from 'case-study-lib/utils/urls';
import { SETTINGS_MODAL } from '../../constants';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { cloneInstance, deleteInstance } from '../../api';
import DeleteCaseStudyModal from './DeleteCaseStudyModal';
import CloneCaseStudyModal from './CloneCaseStudyModal';
import ContentPublishStatus from 'ContentEditorUI/components/shared/ContentPublishStatus';
import { selectIsInstancePublished } from '../../data/editor/publish';
import { OnboardingTourStepTitle } from './OnboardingTour';
import { NavMarker } from 'react-rhumb';
import ContentCrmObjectProvider from 'ContentEditorUI/components/publishing/ContentCrmObjectProvider';
import { ContentObjectTypes } from 'content-management-data-lib';
import { selectIsUngatedForCMPPublicationAPIs } from '../../data/auth';
import { selectActiveHubDbRowId } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorToolbarEndSlot = () => {
  const dispatch = useAppDispatch();
  const isSavePermanentlyDisabled = useSelector(getIsSavePermanentlyDisabled);
  const isCanSave = useAppSelector(selectCanSave);
  const hasEmptyTitle = useAppSelector(selectHasEmptyTitle);
  const saveState = useSelector(getSaveState);
  const lastSave = useSelector(getLastSaveDate);
  const isUserJitad = useSelector(getIsUserJitad);
  const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
  const handlePreviewClick = useCallback(() => {
    if (hasUnsavedChanges) {
      dispatch(showLoading());
      dispatch(save()).finally(() => {
        dispatch(hideLoading());
        dispatch(routeToPage('preview'));
      }).catch(error => console.error(error));
    } else {
      dispatch(routeToPage('preview'));
    }
  }, [dispatch, hasUnsavedChanges]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BaymaxSaveButton, {
      allowedSave: isCanSave,
      allowedSaveDisabledTooltip: hasEmptyTitle ? I18n.text('caseStudyEditor.saveButtonEmptyTitleTooltip') : undefined,
      contentTypeNoun: I18n.text('caseStudyEditor.contentTypeNoun'),
      isDisabled: !isCanSave,
      onSaveClick: () => dispatch(save()),
      permanentlyDisabled: isSavePermanentlyDisabled,
      isUngatedForPatagonia: true,
      shouldShowRevisions: getIsUngatedForRevisionHistory(),
      lastSave: lastSave,
      saveState: saveState,
      isUserJitad: isUserJitad
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: handlePreviewClick,
      use: "secondary-ghost",
      size: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.tabBar.preview"
      })
    }), /*#__PURE__*/_jsx(CaseStudyPublishButton, {})]
  });
};
export default function Header() {
  const [isDeletingCaseStudy, setIsDeletingCaseStudy] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCloningCaseStudy, setIsCloningCaseStudy] = useState(false);
  const [isCloneModalOpen, setIsCloneModalOpen] = useState(false);
  const navigationGroups = useNavigationGroups({
    onDeleteClick: () => {
      setIsDeleteModalOpen(true);
      //TODO: add usage tarcking
    },
    onCloneClick: () => {
      setIsCloneModalOpen(true);
      //TODO: add usage tarcking
    }
  });
  const dispatch = useDispatch();
  const shouldClearHeader = useSelector(getShouldClearHeaderActiveItem);
  const hasUndoRedoAccess = useSelector(getHasUndoRedoAccess);
  const isReadOnly = useSelector(getIsReadOnlyMode);
  const isPublished = useSelector(selectIsInstancePublished);
  const handleActiveItemChange = useCallback(activeItem => {
    dispatch(updateHeaderActiveItem(activeItem));
    if (activeItem) {
      dispatch(setShouldClearHeaderActiveItem(false));
    }
  }, [dispatch]);
  const {
    search
  } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const instanceName = useSelector(selectInstanceName);
  const groupId = useSelector(selectInstanceGroupId);
  const instanceId = useSelector(selectInstanceId);
  const handleChangeName = ({
    currentTarget: {
      value
    }
  }) => dispatch(updateInstanceValue('hs_name', value));
  const handleDeleteCaseStudy = useCallback(() => {
    setIsDeletingCaseStudy(true);
    deleteInstance(instanceId).then(() => {
      setIsDeletingCaseStudy(false);
      setIsDeleteModalOpen(false);
      window.location.href = getManageGroupUrl(groupId);
    }).catch(() => {
      setIsDeletingCaseStudy(false);
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.delete.deleteInstanceError"
        }),
        type: 'danger'
      });
    });
    //@TODO: if this a case study mlang variation then redirect to primary case study
  }, [groupId, instanceId]);
  const handleCloneCaseStudy = useCallback(cloneName => {
    setIsCloningCaseStudy(true);
    cloneInstance(instanceId, groupId, cloneName).then(response => {
      var _response$values;
      setIsCloningCaseStudy(false);
      setIsCloneModalOpen(false);
      if (response !== null && response !== void 0 && (_response$values = response.values) !== null && _response$values !== void 0 && _response$values.hs_id) {
        window.location.href = getEditorUrl(response.values.hs_id);
      }
    }).catch(() => {
      setIsCloningCaseStudy(false);
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "caseStudyEditor.childMenuItems.clone.cloneInstanceError"
        }),
        type: 'danger'
      });
    });
  }, [groupId, instanceId]);
  const setSettingsModalOpenWithNavItem = useCallback(selectedNavItem => {
    dispatch(updatePatagoniaSettingsModalActiveNavItem(selectedNavItem));
    dispatch(openModal(SETTINGS_MODAL));
  }, [dispatch]);
  const shouldUseCmpPublishHandler = useSelector(selectIsUngatedForCMPPublicationAPIs);
  const caseStudyId = useSelector(selectActiveHubDbRowId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDeleteModalOpen && /*#__PURE__*/_jsx(DeleteCaseStudyModal, {
      onConfirm: handleDeleteCaseStudy,
      onReject: () => setIsDeleteModalOpen(false),
      isDeletingCaseStudy: isDeletingCaseStudy,
      caseStudyName: instanceName
    }), isCloneModalOpen && /*#__PURE__*/_jsx(CloneCaseStudyModal, {
      caseStudyName: instanceName,
      onConfirm: handleCloneCaseStudy,
      onReject: () => setIsCloneModalOpen(false),
      isCloningCaseStudy: isCloningCaseStudy
    }), /*#__PURE__*/_jsx(ContentCrmObjectProvider, {
      contentObjectType: ContentObjectTypes.CASE_STUDY,
      enableScheduledPublishing: shouldUseCmpPublishHandler,
      shouldUseContentCrmObject: shouldUseCmpPublishHandler,
      contentCrmObjectId: caseStudyId,
      children: /*#__PURE__*/_jsx(EPHeader, {
        editorToolbarClassName: "fullscreen-editor-header",
        "data-test-id": "header-container",
        tabsClassName: "m-y-2",
        titleText: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          justify: "center",
          direction: "column",
          children: [/*#__PURE__*/_jsx(OnboardingTourStepTitle, {
            children: /*#__PURE__*/_jsx(UIAutosizedTextInput, {
              error: !instanceName,
              affordance: true,
              onChange: handleChangeName,
              use: "on-dark",
              value: instanceName,
              readOnly: isReadOnly
            })
          }), /*#__PURE__*/_jsx(ContentPublishStatus, {
            isPublished: isPublished
          })]
        }),
        editorToolbarStartSlot: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ExitButton, {
            dashboardUrl: params.get('redirectUrl') || getManageGroupUrl(groupId)
          }), /*#__PURE__*/_jsx(EPNavigationBar, {
            navigationGroups: navigationGroups,
            onActiveItemChange: handleActiveItemChange,
            shouldClear: shouldClearHeader
          })]
        }),
        editorToolbarEndSlot: /*#__PURE__*/_jsx(EditorToolbarEndSlot, {}),
        tabsEndSlot: /*#__PURE__*/_jsx(NavMarker, {
          name: "PARENT_APP_CHROME_RENDERED",
          children: /*#__PURE__*/_jsx(UIFlex, {
            align: "center",
            justify: "end",
            children: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs(UIButton, {
                "data-test-id": "settings",
                className: "p-all-2",
                use: "tertiary-light",
                size: "medium",
                onClick: () => setSettingsModalOpenWithNavItem(SettingsModalSections.general),
                children: [/*#__PURE__*/_jsx(UIIcon, {
                  name: "settings",
                  size: 16
                }), /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "caseStudyEditor.settingsButtonText"
                })]
              }), hasUndoRedoAccess && /*#__PURE__*/_jsx(View, {
                marginInlineStart: "100",
                children: /*#__PURE__*/_jsx(UndoRedoButtonContainer, {
                  isVisible: true,
                  disabled: isReadOnly
                })
              })]
            })
          })
        })
      })
    })]
  });
}